// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "" + "misc-vendors" + "." + "b9746da420699eac15ad" + ".css";
};